<template lang="pug">
.d-flex
  .flex-grow-1
    filter-amount.mr-2(:filter.sync="amountFilter" param="amount_total")
    filter-amount.mr-2(:filter.sync="balanceFilter" title="Unpaid balance" param="amount_remaining")
    filter-invoice-no.mr-2(:filter.sync="sellerFilter")
    filter-seller.mr-2(:filter.sync="sellerFilter")
    filter-date.mr-2(:filter.sync="dueDateFilter" title="Due date" param="due_at")
    filter-date.mr-2(:filter.sync="dateFilter" title="Date issued" param="record_date")
  v-btn.button-sm.underline.px-0(text @click="resetFilters" :disabled="allFilters.length === 0") Reset filters
</template>

<script>
import FilterAmount from '@/components/module/filter/FilterAmount.vue'
import FilterInvoiceNo from '@/components/module/filter/FilterInvoiceNo.vue'
import FilterSeller from '@/components/module/filter/FilterSeller.vue'
import FilterDate from '@/components/module/filter/FilterDate.vue'

export default {
  name: 'FilterRow',
  components: { FilterAmount, FilterInvoiceNo, FilterSeller, FilterDate },
  props: ['filters'],
  data: () => ({
    amountFilter: {},
    balanceFilter: {},
    invoiceNoFilter: {},
    sellerFilter: {},
    dueDateFilter: {},
    dateFilter: {},
  }),
  computed: {
    allFilters () {
      const filters = []
      if (this.amountFilter.key) {
        if (this.amountFilter.key === 'between') {
          const values = this.amountFilter.value
          for (const i in values) {
            filters.push(values[i])
          }
        } else {
          filters.push(this.amountFilter)
        }
      }
      if (this.balanceFilter.key) {
        if (this.balanceFilter.key === 'between') {
          const values = this.balanceFilter.value
          for (const i in values) {
            filters.push(values[i])
          }
        } else {
          filters.push(this.balanceFilter)
        }
      }
      if (this.invoiceNoFilter.key) {
        filters.push(this.invoiceNoFilter)
      }
      if (this.sellerFilter.key) {
        filters.push(this.sellerFilter)
      }
      if (this.dueDateFilter.key) {
        if (this.dueDateFilter.key === 'between') {
          const values = this.dueDateFilter.value
          for (const i in values) {
            filters.push(values[i])
          }
        } else {
          filters.push(this.dueDateFilter)
        }
      }
      if (this.dateFilter.key) {
        if (this.dateFilter.key === 'between') {
          const values = this.dateFilter.value
          for (const i in values) {
            filters.push(values[i])
          }
        } else {
          filters.push(this.dateFilter)
        }
      }
      return filters
    }
  },
  watch: {
    allFilters (newValue) {
      this.$emit('update:filters', newValue)
    }
  },
  methods: {
    resetFilters () {
      this.amountFilter = {}
      this.balanceFilter = {}
      this.invoiceNoFilter = {}
      this.sellerFilter = {}
      this.dueDateFilter = {}
      this.dateFilter = {}
    }
  }
}
</script>